import axios from 'axios'
import { BASEURL } from './api.variables'

const CATEGORIESURL = (limit, skip, lang) => `${BASEURL}/categories?limit=${limit}&skip=${skip}&language=${lang}`

const headers = () => {
  return {
    Authorization: document.redecienciaToken ? `Bearer ${document.redecienciaToken}` : ''
  }
}

const GetCategories = (limit = 50, skip = 0, lang = 'pt') => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: CATEGORIESURL(limit, skip, lang),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

export {
  GetCategories
}



// WEBPACK FOOTER //
// ./src/api/category.js